import apiClient from "./axios"

export const getDailyReports = async (params = {}) => {
  const { data } = await apiClient.get("/daily-reports", { params })
  return data
}

export const getDailyReport = async id => {
  const { data } = await apiClient.get(`/daily-reports/${id}`)
  return data
}

export const generateDailyReport = async payload => {
  const { data } = await apiClient.post("/daily-reports/generate", payload)
  return data
}

export const downloadDailyReportPdf = async id => {
  const response = await apiClient.get(`/daily-reports/${id}/pdf`, {
    responseType: "blob",
  })
  return response.data
}
